import React, { useState, useRef } from 'react';
import styles from './login.module.scss';

const VerificationForm = ({ email }) => {
  const [verificationCode, setVerificationCode] = useState(['', '', '', '', '', '']); // Store individual digits
  const [isCodeFullyEntered, setIsCodeFullyEntered] = useState(false); // Track if all inputs are filled
  const inputRefs = useRef([]); // Array to hold references to input fields

  // Handle individual input change and auto-focus
  const handleInputChange = (e, index) => {
    const newCode = [...verificationCode];
    newCode[index] = e.target.value.slice(0, 1); // Only take the first character (digit)
    setVerificationCode(newCode);

    // Check if all fields are filled
    if (newCode.every((digit) => digit !== '')) {
      setIsCodeFullyEntered(true); // Set flag to true if all inputs are filled
    } else {
      setIsCodeFullyEntered(false); // Reset flag if not all inputs are filled
    }

    // Focus on the next input field if available
    if (e.target.value && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  // Handle backspace and focus on the previous input
  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !verificationCode[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  return (
    <div className="formContainer">
      <form className="form">
        <div className={styles.otpFieldContainer}>
          <div className={styles.otpTextContainer}>
            <h2 className="title">A verification code has been sent to your email address</h2>
            <h2 className={styles.email_title}>{email}</h2>
            <h2 className="title">Enter the code below.</h2>
          </div>
          <div className={styles.otpInputContainer}>
            {verificationCode.map((digit, index) => (
              <input
                key={index}
                type="text"
                value={digit}
                onChange={(e) => handleInputChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                maxLength="1"
                ref={(el) => (inputRefs.current[index] = el)} // Attach reference
                required
                className={styles.otpInput}
                pattern="[0-9]" // Ensure only digits can be entered
              />
            ))}
          </div>
        </div>
        {!isCodeFullyEntered && (
          <div className={styles.buttonsContainerArea}>
            <button type="button" className={styles.ChangeMailButton}>
              Change Email
            </button>
            <button type="button" className={styles.ResendCodeButton}>
              Resend code
            </button>
          </div>
        )}
        {isCodeFullyEntered && (
          <button type="submit" className={styles.loginButton}>
            Log In
          </button>
        )}
      </form>
    </div>
  );
};

export default VerificationForm;
